import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { usePaginatedCollectionStateContext } from 'Context/PagedCollectionStateContext';
import NullComponent from 'Components/UI/NullComponent';
import { AdminItemTable } from './AdminItemTable';

const ItemListContainer = () => {
  const {
    collection,
    loadingError,
  } = usePaginatedCollectionStateContext();

  return (
    <DataContainer
      component={AdminItemTable}
      loading={!collection}
      loadingError={loadingError}
      skeleton={NullComponent}
    />
  );
};

export { ItemListContainer };
